import { SortableElement } from 'react-sortable-hoc';

const ColSortableItem = SortableElement(({ children, itemIndex, item }) => children(item, itemIndex));

export default ColSortableItem;
